import type { MultiBrandConfig } from './types';

// Website 02 — Bold Fast-Activation storefront. Working brand: eSIMCobra.
// Identity carried forward from the redesign/esimcobra-ui-ux branch (the
// brutalist "Strike" system). Name/domain are PROVISIONAL.
//
// NOTE ON DOMAIN: this currently points at esimsupra.com because the redesign
// branch reused the eSIMSUPRA backend/infra untouched. Before eSIMCobra is
// deployed as its own indexed property it MUST get its own canonical domain to
// avoid cross-brand duplicate-content / canonical conflicts (risk R14 in
// docs/multi-brand/risk-register.md). Until then this brand is build-selectable
// for preview only (BRAND_ID=bold-fast-activation).
export const esimcobra: MultiBrandConfig = {
  id: 'bold-fast-activation',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'High-energy brutalist direct-response storefront for urgent buyers and speed-focused paid traffic.',
  theme: {
    mode: 'light', // redesign is light-first ("Strike" system)
    defaultDark: 'venom-night',
    defaultLight: 'venom-strike',
  },
  checkoutEnabled: true,
  // Deal/speed-first brand: lead with the cheapest entry price. Presentation only.
  pricingDisplayMode: 'lowest-entry',
  legacy: {
    brand: {
      name: 'eSIMCobra',
      displayName: 'eSIMCobra',
      tagline: 'Strike Online In 60 Seconds — Travel eSIM',
      description:
        'Sharp travel eSIMs for 180+ countries. Instant activation, local data, zero roaming surprises.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'eSIMCobra Logo',
    },
    contact: {
      // Shared support inbox for now (shared backend). Swap to a brand inbox at launch.
      // TODO(brand-email): planned dedicated inbox `support@esimcobra.com` (TBD) before indexed launch (R14).
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      // PROVISIONAL — see domain note above. Own domain required before launch.
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} eSIMCobra. All rights reserved.`,
    },
    features: {
      count180Countries: '180+ Countries',
      uptimePerformance: 'Partner Networks',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for esimcobra.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'COBRA',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'esimcobra.com',
      url: 'https://esimcobra.com',
      organizationLegalName: 'TBD — register legal entity for eSIMCobra',
    },
    llms: {
      tagline: 'Strike Online In 60 Seconds — Travel eSIM',
      audience: 'Urgent and last-minute travelers who want fast, no-frills eSIM activation.',
    },
  },
};

export default esimcobra;
